import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=aca94f1e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=aca94f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca94f1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aca94f1e')) {
      api.createRecord('aca94f1e', component.options)
    } else {
      api.reload('aca94f1e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=aca94f1e&scoped=true&", function () {
      api.rerender('aca94f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OhOW12vVVT0e/JS/comp/GuestBox.vue"
export default component.exports